"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tailRec = void 0;
/**
 * @since 2.0.0
 */
var tailRec = function (startWith, f) {
    var ab = f(startWith);
    while (ab._tag === 'Left') {
        ab = f(ab.left);
    }
    return ab.right;
};
exports.tailRec = tailRec;



//////////////////
// WEBPACK FOOTER
// ./~/fp-ts/lib/ChainRec.js
// module id = 1820
// module chunks = 1